export default __webpack_public_path__ + "static/media/subtitle.eb608e21.svg";